import { ReactComponent } from "./image-fill.svg";

interface Props {
  fill?: string;
  width?: string;
  height?: string;
}

const ImageFillIcon: React.FC<Props> = (props) => <ReactComponent {...props} />;

export default ImageFillIcon;
